import type { DeutscheBahnPassenger } from "../types";

// Full name of the first traveller, used to prefill the guest name on the summary screen.
export const getDeutscheBahnFirstTravelerName = (passengerList: DeutscheBahnPassenger[] | null | undefined): string => {
  const firstTraveler = passengerList?.[0];

  return [firstTraveler?.first_name, firstTraveler?.last_name]
    .map(part => part?.trim())
    .filter(Boolean)
    .join(" ");
};
